import styled from 'styled-components'
import { FaTrashAlt } from 'react-icons/fa'

export const IconRemove = styled(FaTrashAlt).attrs(() => ({
  size: '16px'
}))`
  cursor: pointer;
`
